import { createBrowserRouter } from 'react-router';

// Skeleton router — frontend-dev fills in the full route tree per architecture.md page map.
// Every route uses { lazy: () => import(...) } so route modules code-split.
export const router = createBrowserRouter([
  {
    path: '/',
    lazy: () => import('./pages/_layout/root'),
    children: [
      { index: true, lazy: () => import('./pages/home') },
      // public — vehicles
      { path: 'vehicles', lazy: () => import('./pages/vehicles/list') },
      { path: 'vehicles/:id', lazy: () => import('./pages/vehicles/detail') },
      { path: 'vehicles/:id/reserve', lazy: () => import('./pages/vehicles/reserve') },
      { path: 'vehicles/:id/buy', lazy: () => import('./pages/vehicles/buy') },
      // public — rentals
      { path: 'rentals', lazy: () => import('./pages/rentals/list') },
      { path: 'rentals/:id', lazy: () => import('./pages/rentals/detail') },
      { path: 'rentals/:id/book', lazy: () => import('./pages/rentals/book') },
      // public — parts
      { path: 'parts', lazy: () => import('./pages/parts/list') },
      { path: 'parts/:id', lazy: () => import('./pages/parts/detail') },
      { path: 'cart', lazy: () => import('./pages/cart') },
      { path: 'checkout', lazy: () => import('./pages/checkout') },
      { path: 'thank-you', lazy: () => import('./pages/thank-you') },
      // editorial
      { path: 'about', lazy: () => import('./pages/about') },
      { path: 'contact', lazy: () => import('./pages/contact') },
      { path: 'terms', lazy: () => import('./pages/legal/terms') },
      { path: 'privacy', lazy: () => import('./pages/legal/privacy') },
    ],
  },
  // admin
  { path: '/admin/login', lazy: () => import('./pages/admin/login') },
  {
    path: '/admin',
    lazy: () => import('./pages/_layout/admin'),
    children: [
      { index: true, lazy: () => import('./pages/admin/dashboard') },
      { path: 'vehicles', lazy: () => import('./pages/admin/vehicles/list') },
      { path: 'vehicles/new', lazy: () => import('./pages/admin/vehicles/new') },
      { path: 'vehicles/import', lazy: () => import('./pages/admin/vehicles/import') },
      { path: 'vehicles/:id', lazy: () => import('./pages/admin/vehicles/edit') },
      { path: 'parts', lazy: () => import('./pages/admin/parts/list') },
      { path: 'parts/new', lazy: () => import('./pages/admin/parts/new') },
      { path: 'parts/import', lazy: () => import('./pages/admin/parts/import') },
      { path: 'parts/:id', lazy: () => import('./pages/admin/parts/edit') },
      { path: 'enquiries', lazy: () => import('./pages/admin/enquiries/list') },
      { path: 'orders', lazy: () => import('./pages/admin/orders/list') },
      { path: 'orders/:id', lazy: () => import('./pages/admin/orders/detail') },
      { path: 'rentals', lazy: () => import('./pages/admin/rentals/calendar') },
    ],
  },
]);
